module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"flowText":"下行单节点带宽（Mbps）","cpuText":"CPU使用率（百分比）","memText":"内存使用率（百分比）","diskIoText":"节点磁盘IO"}}')
  delete Component.options._Ctor
}
